import noop from 'lodash/noop';
import { useEffect } from 'react';
import { interactionWrapper } from '../utils';
/**
 * Same as `useEffect` but wraps the effect in interactionWrapper and calls
 * cancellation during cleanup lifecycle to prevent interaction-frozen calls
 * from firing during the wrong render or when unmounted.
 */
export const useInteractionEffect = (effect, deps) => {
    useEffect(() => {
        let destructor = noop;
        const ret = interactionWrapper(effect);
        ret.then((d) => (destructor = d || noop));
        return () => {
            ret.cancel();
            destructor();
        };
    }, deps);
};
//# sourceMappingURL=useInteractionEffect.js.map